<template>
<div style="margin: 0 20px">
  <el-form style="margin-right: 20px" :model="subForm" :rules="subRules" ref="subForm" label-width="90px" class="demo-ruleForm">
    <div v-if="moduletag === 2">
      <el-form-item label="绑定床位" prop="bid">
        <el-select v-fixZoom v-model="subForm.bid" filterable placeholder="请选择" :clearable="false" style="width:100%;">
          <el-option v-for="item in bedArr" :key="item.index" :label="item.showName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装位置" prop="">
        <el-input placeholder="请输入安装位置" v-model="subForm.install_location"></el-input>
      </el-form-item>
    </div>
    <div v-else>
      <el-form-item label="所属人员" label-width="90px" prop="pid">
        <el-select v-fixZoom v-if="!isBind" style="width: 100%" filterable v-model="subForm.pid" placeholder="请选择所属人员" @change="selectPerson">
          <el-option v-for="item in selectoldpersons" :key="item.index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span v-else>{{personDevice.person_name}}</span>
      </el-form-item>
      <el-form-item label="安装位置" prop="">
        <el-input v-if="!isBind" placeholder="请输入安装位置" v-model="subForm.install_location"></el-input>
        <span v-else>{{personDevice.install_location}}</span>
      </el-form-item>
    </div>
  </el-form>
  <div>
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAdd()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div v-if="!isBind" class="send-btn" @click="getSendSubDeviceBed('subForm')">
          <span>确定</span>
        </div>
        <div v-else class="send-btn" @click="unbindPerson(personDevice)">
          <span>解绑老人</span>
        </div>
      </el-col>
    </el-row>
  </div>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {queryChildrenOrgByEid, queryChildrenOrgByOrgId} from '../../../api/organizer'
import {queryOrgHomeByOrgId} from '../../../api/yanglaoyuan/orgHome'
import {queryhomebed} from '../../../api/yanglaoyuan'
import {bindsubdevice, querysubdevicebind, unbindsubdevice} from '../../../api/device'
import {queryoldpersonbyhids} from '../../../api/handlealarm'

export default {
  name: 'subDeviceBed',
  model: {
    prop: 'subShow',
    event: 'change'
  },
  props: {
    subBedObj: {
      type: Object
    }
  },
  data () {
    return {
      subList: [],
      bedArr: [],
      optionProps: {
        value: 'id',
        label: 'name',
        lazy: true,
        emitPath: false,
        showAllLevels: true,
        lazyLoad: async (node, resolve) => {
          let nodes = []
          if (node.level === 0) {
            nodes = await this.getOrgData()
          } else if (node.data.org_type === 0 || node.data.org_type === 1) {
            nodes = await this.getOrgChildData(node.value)
          } else if (node.data.org_type === 2) {
            nodes = await this.getOrgHomeData(node.value)
          } else {
            nodes = await this.getHomeBedData(node.value)
          }
          resolve(nodes)
        }
      },
      subForm: {
        sub_deviceid: '',
        main_did: '',
        'bind_type': 1, // 1:床位.2:房间.3楼层.4老人
        'bid': '',
        'hid': '',
        orgid: '',
        pid: '',
        'install_location': '',
        'phone': ''
      },
      subRules: {
        bid: [
          { required: true, message: '请选择床位', trigger: 'change' }
        ],
        pid: [
          { required: true, message: '请选择所属人员', trigger: 'change' }
        ]
      },
      selectoldpersons: [],
      moduletag: '',
      isBind: false,
      personDevice: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    if (this.subBedObj.isMain) {
      this.setBindPerson(this.subBedObj.device)
      // device.vue页面设置睡眠带分配老人
      this.subForm = {
        sub_deviceid: this.subBedObj.device.deviceid,
        main_did: this.subBedObj.device.id,
        'bind_type': this.moduletag === 2 ? 1 : 4, // 1:床位.2:房间.3楼层.4老人
        'bid': '',
        'hid': this.subBedObj.device.hid,
        orgid: this.subBedObj.device.oid,
        pid: '',
        'install_location': '',
        'phone': this.subBedObj.device.phone
      }
    } else {
      this.subForm = {
        sub_deviceid: this.subBedObj.subItem.sub_deviceid,
        main_did: this.subBedObj.subItem.main_did,
        'bind_type': this.moduletag === 2 ? 1 : 4, // 1:床位.2:房间.3楼层.4老人
        'bid': '',
        'hid': this.subBedObj.device.hid,
        orgid: this.subBedObj.device.oid,
        pid: '',
        'install_location': this.subBedObj.subItem.install_location,
        'phone': this.subBedObj.subItem.phone
      }
    }
    if (this.moduletag === 2) {
      this.gethomebed()
    } else {
      if (this.subBedObj.isMain) {
        this.setBindPerson(this.subBedObj.device)
      } else {
        this.selectHomeID()
      }
    }
  },
  methods: {
    // 查询是否绑定
    setBindPerson (row) {
      let data = {
        sub_deviceid: row.deviceid,
        main_did: row.id,
        bind_type: 4
      }
      querysubdevicebind(data).then(res => {
        if (res.data.bindsubdevices.length > 0) {
          this.personDevice = res.data.bindsubdevices[0]
          this.isBind = true
        } else {
          this.selectHomeID()
        }
      }).catch(() => {})
    },
    // 树床位
    async getOrgData () {
      let arr = []
      let data = { eid: this.$store.state.user.LoginResp.entity_id }
      await queryChildrenOrgByEid(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgChildData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryChildrenOrgByOrgId(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgHomeData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryOrgHomeByOrgId(data).then(res => {
        if (res.data.orghomes) {
          res.data.orghomes.forEach(orgHome => {
            orgHome.leaf = false
            orgHome.name = orgHome.room
            arr.push(orgHome)
          })
        }
      })
      return arr
    },
    async getHomeBedData (id) {
      let arr = []
      let data = {
        hid: id
      }
      await queryhomebed(data).then(res => {
        if (res.data.homebed) {
          res.data.homebed.forEach(homeBed => {
            homeBed.leaf = true
            homeBed.name = homeBed.bed_name
            arr.push(homeBed)
          })
        }
      })
      console.log(arr)
      return arr
    },
    // 床位
    gethomebed () {
      let data = {
        hid: this.subBedObj.device.hid
      }
      queryhomebed(data).then(res => {
        this.tableData = res.data.homebed
        //  <span>{{scope.row.build_name}} / {{scope.row.floor_name}} / {{scope.row.home_room}}</span>
        let arr = []
        for (let i = 0; i < res.data.homebed.length; i++) {
          let obj = res.data.homebed[i]
          obj.showName = this.subBedObj.device.build_name + '/' + this.subBedObj.device.floor_name + '/' + this.subBedObj.device.home_room + '/' + obj.bed_name
          arr.push(obj)
        }
        this.bedArr = arr
      })
    },
    closeAdd () {
      this.$emit('change', false)
    },
    getSendSubDeviceBed (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let send = {}
          if (this.moduletag === 2) {
            send = {
              'sub_deviceid': this.subForm.sub_deviceid,
              'main_did': this.subForm.main_did,
              'bind_type': this.subForm.bind_type,
              'bid': this.subForm.bid,
              'hid': this.subForm.hid,
              'phone': this.subForm.phone,
              'install_location': this.subForm.install_location
            }
          } else {
            send = {
              'sub_deviceid': this.subForm.sub_deviceid,
              'main_did': this.subForm.main_did,
              'bind_type': this.subForm.bind_type,
              'pid': this.subForm.pid,
              'hid': this.subForm.hid,
              'phone': this.subForm.phone,
              'install_location': this.subForm.install_location
            }
          }
          bindsubdevice(send).then(res => {
            this.$notify({title: '成功', message: '成功绑定', type: 'success'})
            this.$emit('change', false)
            this.golobleObject.addSubNew()
          }).catch(() => {
          })
        }
      })
    },
    // 居家 解绑老人
    unbindPerson (row) {
      let data = {
        'sub_deviceid': row.sub_deviceid,
        'main_did': row.did,
        'bind_type': 4,
        'pid': row.pid,
        'hid': row.hid
      }
      unbindsubdevice(data).then(res => {
        this.$notify({title: '成功', message: '成功解绑', type: 'success'})
        this.$emit('change', false)
        this.golobleObject.addSubNew()
      }).catch(() => {})
    },
    selectHomeID () {
      let data = {
        hids: [this.subBedObj.isMain ? this.subBedObj.device.hid : this.subBedObj.device.hid]
      }
      queryoldpersonbyhids(data).then(res => {
        this.selectoldpersons = res.data.persons
      }).catch(() => {})
    },
    selectPerson (id) {
      console.log(this.subForm)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/subDeviceBed.vue